<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="dutyTimeBufferAudits && dutyTimeBufferAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="dutyTimeBufferAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Duty Time Buffer audits </ng-template>
</ng-template>
